import React, { useState, useEffect } from "react";
import ReactDatePicker from "react-datepicker";

import ic_search from "assets/images/ic_search.svg";

import ic_date from 'assets/images/ic_date.svg';

import { isFunction, isNotNullUndefined, isNullUndefined, isObjectNotEmpty, isStringTrimEmpty, isStringTrimNotEmpty } from 'functions';

import "react-datepicker/dist/react-datepicker.css";
import "assets/scss/components/form/datepicker.scss";
import { isDateValid } from "../../functions/func_validation";
import moment from "moment";



export function Datepicker(props) {
    const {
        className, inputClassName, labelWrapperClassName, inputWrapperClassName,
        label, isInputRequired,
        dateFromParent, defaultDate, dateFormat,
        errorMsg, customErrorValidation,
        isFormSubmissionAttempted,
        placeholder,
        otherOptions,
        isSearchIconVisible, isSideIconHidden,
        isFormatConversionRequired_fromDDMMYYYY,
        isResetRequired, isMonthYear, isDisabled, minDate, maxDate
    } = props;

    let label_validated = isStringTrimNotEmpty(label) ? label : "";
    let dateFormat_formatted = isStringTrimNotEmpty(dateFormat) ? dateFormat : "dd/MM/yyyy";
    let errorMsg_validated = isStringTrimNotEmpty(errorMsg) ? errorMsg : "";
    let otherOptions_validated = isObjectNotEmpty(otherOptions) ? otherOptions : {};

    // Date Conversion
    function handleDateFormat(date) {
        let dateConverted = date;
        if (isFormatConversionRequired_fromDDMMYYYY &&
            isStringTrimNotEmpty(date)) {

            let dateValues = date.split("/");
            dateConverted = dateValues[1] + "/" + dateValues[0] + "/" + dateValues[2];
            return new Date(dateConverted);
        }
        else if (isDateValid(date))
            return new Date(date);
        else return "";
    }

    // States
    let defaultDate_formatted = handleDateFormat(defaultDate);
    const [date, setDate] = useState(defaultDate_formatted);

    let placeholder_validated = isStringTrimNotEmpty(placeholder) ? placeholder : "";

    function handleChange(newDate) {
        setDate(newDate);

        if (isNotNullUndefined(newDate) &&
            isFunction(props.handleOnChange))
            props.handleOnChange(handleDateConversion(newDate));

        if (isNullUndefined(newDate) &&
            isFunction(props.handleOnEmptyInput))
            props.handleOnEmptyInput();
    }
    function updateStateFromParent() {
        if (isNotNullUndefined(dateFromParent)) {
            setDate(handleDateFormat(dateFromParent));
        }
    }
    function handleSelect(newDate) {
        if (isNotNullUndefined(newDate) &&
            isFunction(props.handleOnSelect))
            props.handleOnSelect(handleDateConversion(newDate));
    }
    useEffect(() => {
        updateStateFromParent();
    }, [dateFromParent]);

    function handleDateConversion(date) {
        const { isConversionRequired_ISO8601 } = props;

        let date_formatted = new Date(date);
        if (isConversionRequired_ISO8601) {
            date_formatted.setUTCHours(date_formatted.getUTCHours() + 8);
            date_formatted = date_formatted.toISOString();
        }

        return moment(date_formatted).format("YYYY-MM-DD");
    }

    function reset() {
        if (isResetRequired)
            setDate(defaultDate_formatted);
    }
    useEffect(() => {
        reset();
    }, [isResetRequired]);

    let isErrorPresent = isFormSubmissionAttempted &&
        (isStringTrimEmpty(date) || isNullUndefined(date)) &&
        (errorMsg_validated != "");
    if (customErrorValidation) isErrorPresent = customErrorValidation;

    return (
        <div className={"component-datepicker " +
            (className ? className + " " : "")}>

            {/* Label */}
            <div className={"component-datepicker-labelWrapper " +
                (labelWrapperClassName ? labelWrapperClassName + " " : "")}>
                <span className={"component-datepicker-label"}>{label_validated}</span>
                {isInputRequired ? (<span className={"component-datepicker-label-requiredSymbol"}>*</span>) : ""}
            </div>

            {/* Input */}
            <div className={"component-datepicker-inputWrapper " +
                (inputWrapperClassName ? inputWrapperClassName + " " : "")}
            >
                <ReactDatePicker
                    className={(inputClassName ? inputClassName + " " : "") +
                        (isErrorPresent ? "component-datepicker-input_errorBorder " : "") +
                        (isSearchIconVisible ? "component-datepicker-input_iconPadding " : "")}
                    selected={date}
                    onChange={handleChange}
                    onSelect={handleSelect} // when day is clicked
                    dateFormat={dateFormat_formatted}
                    showMonthYearPicker={isMonthYear}
                    disabled={isDisabled}
                    showPopperArrow={false}
                    minDate={minDate}
                    maxDate={maxDate}

                    autoComplete={"off"}

                    popperModifiers={{
                        preventOverflow: {
                            enabled: true,
                            escapeWithReference: false,
                            boundariesElement: "viewport"
                        }
                    }}

                    placeholderText={placeholder_validated}

                    {...otherOptions_validated}
                />

                {/* Search Icon */}
                {isSearchIconVisible ? (
                    <img
                        className={"component-datepicker-searchIcon"}
                        src={ic_search}
                        alt={"Side input icon"}
                    />
                ) : ""}

                {/* Side Icon */}
                {((!isSearchIconVisible) && (!isSideIconHidden)) ? (
                    <img
                        className={"component-datepicker-sideIcon"}
                        src={ic_date}
                        alt={"Side Icon"}
                    />
                ) : ""}
            </div>

            {/* Error Message */}
            {isErrorPresent ? (
                <div className={"component-datepicker-errorMsg"}>
                    {errorMsg_validated}
                </div>
            ) : ""}

        </div>
    );
}